<template>
  <div class="profile-property__input-inner">
    <input
      type="text"
      class="profile-property__input common"
      v-model="val"
      v-number-only
      @focusout="onFocusOut"
      :class="{'input__error': !isValid}">
    <div
      v-if="isShowError"
      class="profile-property__error">
      Данный ИНН уже существует, авторизируйтесь под другим пользователем
    </div>
  </div>
</template>

<script>
  import Parent from './Parent'
  import isEmpty from 'lodash/isEmpty'
  import {mapActions} from 'vuex'

  export default {
    name: 'Inn',
    mixins: [Parent],
    data: function () {
      return {
        isShowError: false
      }
    },
    computed: {
      val: {
        get: function () {
          const value = this.property.value
          const isValid = this.validate(value)
          this.$emit('onChangeValidation', {
            code: this.property.code,
            value: isValid
          })
          this.isValid = isValid
          return value
        },
        set: function (val) {
          this.$emit('onChangeValue', {
            code: this.property.code,
            value: val
          })
        }
      }
    },
    methods: {
      ...mapActions('profile', [
        'checkInn'
      ]),
      validate: function (val) {
        return !isEmpty(val) && (val.length === 10 || val.length === 12)
      },
      onFocusOut: async function () {
        const value = this.property.value
        const isValid = await this.checkInn(value)

        this.$emit('onChangeValidation', {
          code: this.property.code,
          value: isValid
        })
        this.isValid = isValid && this.isValid
        this.isShowError = !isValid
      }
    },
    directives: {
      numberOnly: {
        bind: function (el) {
          el.handler = function () {
            el.value = el.value.replace(/[^\d]/g, '')
          }
          el.addEventListener('input', el.handler)
        },
        unbind: function (el) {
          el.removeEventListener('input', el.handler)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/Inputs/Inn.vue